import React from 'react';
import Root from '@/root';
import { useStoreState } from '@/store';
import { checkImageEditor } from '@/utils/common';
import Contrast from './contrast';
import Helper from './help';

const Content = () => {
    const isImageEditor = checkImageEditor();
    const naturalImage = useStoreState((state) => state.imageEditorModel.naturalImage);

    return (
        <>
            {/* 图片编辑器对比图 */}
            {isImageEditor && naturalImage ? <Contrast /> : null}
            {/* 帮助 */}
            <Helper />
        </>
    );
};

export const StageToolbar = React.memo(() => {
    return (
        <Root>
            <Content />
        </Root>
    );
});
